import React, { useEffect, useRef, useState } from 'react';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import About from './About';
import WhyChooseUs from './WhyChooseUs';
import FAQ from './FAQ';
import Contact from './Contact';
import Footer from './Footer';
import SEOHead from './SEOHead';
import CookieBanner from './CookieBanner';
import LegalModal from './LegalModal';
import { LegalProvider } from '../context/LegalContext';
import '../styles/landing.css';

const LandingPage = () => {
  const containerRef = useRef(null);
  const [activeSection, setActiveSection] = useState('inicio');

  useEffect(() => {
    // Native browser scroll (no library) — feels perfect with touchpad two-finger gestures
    // and mobile touch. Anchor clicks use scrollIntoView({behavior:'smooth'}) for smooth jumps.

    // Intersection Observer for active nav section highlighting
    const sections = document.querySelectorAll('section[id]');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection((prev) => (prev === entry.target.id ? prev : entry.target.id));
          }
        });
      },
      { threshold: 0.5, rootMargin: '-15% 0px -15% 0px' }
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <LegalProvider>
      <SEOHead />
      <div ref={containerRef} className="landing-container">
        <Header activeSection={activeSection} />
        <Hero />
        <Services />
        <About />
        <WhyChooseUs />
        <FAQ />
        <Contact />
        <Footer />
      </div>
      <CookieBanner />
      <LegalModal />
    </LegalProvider>
  );
};

export default LandingPage;
